<script setup>
import Sugar from "sugar"
Sugar.extend({
  namespaces: [Date]
})
const { user} = useUserSession();
const loggedInAt = (Sugar.Date.create(user.loggedInAt)).format("%Y-%m %r");
const links = [
  {
    icon: 'mdi-magnify',
    href:"",
    external: false
  },
  {
    icon: 'mdi-gmail',
    href: "mailto:dream.forge.evo@gmail.com",
    exteranl: true
  }
]
</script>
<template>
  <v-app-bar flat class="">
    <template v-slot:prepend>
      <app-logo-front-page class="d-none d-sm-block" />
      <v-app-bar-nav-icon class="d-flex d-md-none"  @click="$emit('showMenu', true)" />
    </template>
    <template v-slot:append>
      <div>
        <v-btn v-for="link in links" :key="link.icon" :icon="link.icon" class="" variant="text" :href="link.href"
          target="link.external?'_blank':''">
        </v-btn>
      </div>
      <div class="text-body-2 mr-2 d-none d-md-block">{{ user?.name||"" }}您好</div>
      <app-avatar />
    </template>
  </v-app-bar>
</template>

<style scoped>

</style>